import React from "react";
import styled from "styled-components";
import { ContentBuilderType } from "../../../constants/types/acf/content-builder-types";
import { titleToUrl } from "../../../utils";
import { RichText } from "../../atoms/RichText";
import { GravityForm } from "../GravityForm";

interface Props {
    content?: ContentBuilderType;
}

const Section = styled.div`
    margin: 48px 0;

    &:first-child {
        margin-top: 0;
    }
    &:last-child {
        margin-bottom: 0;
    }
`;

const RichTextStyleOverride = styled.div`
    /* Compensate for forced H2s at the start of each Rich Text block */
    h2 {
        + h1,
        + h2,
        + h3,
        + h4,
        + h5,
        + h6 {
            margin-top: 32px;
        }
    }
`;

export const ContentBuilder: React.FC<Props> = props => {
    const blocks = props.content?.[0].content_builder || [];

    return (
        <div>
            {blocks.map((block, index) => {
                let layout;
                switch (block.acf_fc_layout) {
                    case "rich_text":
                        layout = (
                            <RichTextStyleOverride>
                                <RichText
                                    content={
                                        `<h2 id="${titleToUrl(block.section_title)}">${
                                            block.section_title
                                        }</h2>` + block.content
                                    }
                                />
                            </RichTextStyleOverride>
                        );
                        break;
                    case "gravity_form":
                        layout = <GravityForm title={block.section_title} formId={block.form_id} />;
                        break;
                    default:
                        layout = <p>Unknown layout</p>;
                        break;
                }
                return <Section key={index}>{layout}</Section>;
            })}
        </div>
    );
};
